// Contacts → Residents (/app/contacts?sub=residents; residents) — the people on live tenancies, so the tenancy list seen
// from the person's side. A row opens the tenancy. "Export CSV" goes up to the page header.
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useList } from '../../hooks/useList';
import { DataTable, type Column } from '../ui/DataTable';
import { Badge, Money, type MenuEntry } from '../ui';
type T = Record<string, any>;

export function ResidentsTab({ onMenu }: { onMenu: (m: MenuEntry[]) => void }) {
  const navigate = useNavigate(); const list = useList<T>('/tenancies', { status: 'ACTIVE' }, { perPage: 50 });
  const queryKey = JSON.stringify(list.query);
  useEffect(() => {
    onMenu([{ label: 'Export CSV', export: { path: '/tenancies', page: 'tenancies', query: list.query, filename: 'residents.csv' } }]);
    return () => onMenu([]);
  }, [queryKey]); // eslint-disable-line react-hooks/exhaustive-deps
  const columns: Column<T>[] = [
    { key: 'tenants', label: 'Resident', render: (t) => <div><div className="font-medium text-slate-800">{t.tenants?.map((x: Record<string, string>) => x.name).join(', ')}</div><div className="text-xs text-slate-500">{t.tenants?.[0]?.email}</div></div> },
    { key: 'home', label: 'Home', render: (t) => `${t.property?.name} · ${t.unit?.reference}` }, { key: 'rentMinor', label: 'Rent', align: 'right', render: (t) => <Money minor={t.rentMinor} currency={t.rentCurrency} />, hideOnMobile: true }, { key: 'status', label: 'Tenancy', render: (t) => <Badge value={t.status} /> },
  ];
  return <DataTable columns={columns} rows={list.rows} meta={list.meta} page={list.page} onPage={list.setPage} isLoading={list.isLoading} rowKey={(t) => t.id} onRowClick={(t) => navigate(`/app/tenancies/${t.id}`)} search={list.search} onSearch={list.setSearch} searchPlaceholder="Name, unit, property…" />;
}
